import React, { useEffect } from "react";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";

const Brokerage = (props) => {
  let top = props.top;
  let dispatchTop = props.dispatchTop;
  //let setSavedConfigChanged = props.setSavedConfigChanged;

  useEffect(() => {
    if (top.accountNumber === "BACKTEST" && top.brokerage !== "BACKTEST") {
      dispatchTop({ brokerage: "BACKTEST" });
    }
  }, [top.accountNumber]);
  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-evenly"
        alignItems="baseline"
        spacing={2}
      >
        <Grid item>
          <Typography style={{ fontSize: 12 }} color="textSecondary">
            Brokerage:
          </Typography>
        </Grid>
        <Grid item>
          <Typography style={{ fontSize: 12 }}>
            {top.dataSource === "SIMULATED" || top.dataSource === "REPLAY"
              ? "BACKTEST"
              : top.accountNumber && top.accountNumber !== 'none'
                ? top.brokerage && top.brokerage !== 'none'
                  ? top.brokerage
                  : 'Select account'
                : 'Select account'}
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
};

export default Brokerage;
